// extracted by mini-css-extract-plugin
module.exports = {"content":"CommonContentStyle_content__20aP8","identifiers":"CommonContentStyle_identifiers__279Ub"};